// This should have NO dependencies on CMS code, only on geometry.js

// If p1 and p2 overlap,
// Move p1 so that it no longer overlaps p2.
// Return p1
function nudge(p1,p2)
{
    is_inside = function (p1, p2, buffer)  // returns true if the opjects overlap within the buffer
    {

        if( Object.prototype.toString.call( p1 ) === '[object Array]' ) {
            x = is_inside(p1[0], p2[0], buffer)
            y = is_inside(p1[1], p2[1], buffer)
            return x && y
        }
        distance = _.max([p1,p2]) - _.min([p1,p2])
        return distance < buffer
    }

    buffer=45
    out=p1
    if (is_inside(p1, p2, buffer))
    {
        randomnudge = function(buffer)
        {
            return _.random(buffer/2, buffer) * _.sample([1, -1])
        }
        x=p1[0]
        y=p2[1]
        x += randomnudge(buffer)
        y += randomnudge(buffer)
        out=[x,y]
    }
    return out
}

export const DECLUSTER_ENABLED = false;  // AWH TODO put this in the datastore and make it a debug setting

// assume the asset contains adj_coords
function declusterAssets(assets)
{
    // _.forEach(assets, function(asset)
    // {
    //     if(isNaN(asset.adj_coords[0])){
    //         asset.adj_coords[0]=0
    //     }
    //     if(isNaN(asset.adj_coords[1])){
    //         asset.adj_coords[1]=0
    //     }
    // }
    if(!DECLUSTER_ENABLED)
    {
        return assets;
    }
    declusterCore = function()
    {
        _.forEach(assets, function(lhs)
        {
            if (!lhs.adj_coords)
            {
                console.error("asset doesn't have adj_coords: " + lhs.id_asset);
                return;
            }
            _.forEach(assets, function(rhs)
            {
                if (!rhs.adj_coords)
                {
                    console.error("asset doesn't have adj_coords: " + rhs.id_asset);
                    return;
                }
                if(lhs.category == rhs.category) {
                    // only perform decluster of assets that are the same category


                    if(lhs.id_asset == rhs.id_asset) {
                        // lhs and rhs are the same. ignore
                    }
                    else {
                        
                        if(isNaN(lhs.adj_coords[0]) || isNaN(lhs.adj_coords[1]) || isNaN(rhs.adj_coords[0]) || isNaN(rhs.adj_coords[1])){
                            console.error("NaN encountered in declusterAssets()")
                            return
                        }
                        //before = lhs.adj_coords
                        lhs.adj_coords = nudge(lhs.adj_coords, rhs.adj_coords)
                        //after = lhs.adj_coords
                    }
                }
            })
        })
    }

    // run the decluster algorithm multiple times
    declusterCore()
    declusterCore()

    return assets
}


// assume the workorder contains adj_coords
function declusterWorkorders(workorders)
{
    if(!DECLUSTER_ENABLED)
    {
        return workorders;
    }

    declusterCore = function()
    {
        _.forEach(workorders, function(lhs)
        {
            _.forEach(workorders, function(rhs)
            {
                if(lhs.idFloor == rhs.idFloor) {  // make sure the workorders being compared are on the same floor

                    if (lhs.id == rhs.id) {
                        // lhs and rhs are the same workorder. ignore.
                    }
                    else {
                        if(isNaN(lhs.adj_coords[0]) || isNaN(lhs.adj_coords[1]) || isNaN(rhs.adj_coords[0]) || isNaN(rhs.adj_coords[1])){
                            console.error("NaN encountered in declusterWorkorders()")
                            return
                        }
                        lhs.adj_coords = nudge(lhs.adj_coords, rhs.adj_coords)
                    }
                }
            })
        })
    }

    // run the decluster algorithm multiple times
    declusterCore()
    declusterCore()

    return workorders
}


// didValueChange takes two immutable states and a key. returns true if the states are equal for the value at that key. false otherwise
export function didValueChange(imm_state_1, imm_state_2, key){
    return did_value_change(imm_state_1, imm_state_2, key);
}
export function did_value_change(imm_state_1, imm_state_2, key)
{
    // AWH todo: this will fail for non-immutable types
    // consider making non-immutable values immutable. this is expensive, so write out an error to the console so the developer knows to fix their code

    if(imm_state_1==null)
    {
        return imm_state_2 != null
    }


    let v1=imm_state_1.get(key);
    let v2=imm_state_2.get(key);
    if(v1==null)
    {
        return v2 != null;
    }
    if (typeof v1.equals === 'function')
    {
        return !v1.equals(v2);
    }
    return v1 != v2
}

// didChange compares the current and previous state values for a given key
export function didChange(previous_state, immutable_state, key)
{
    return didValueChange(previous_state, immutable_state, key)
}

export function didAnyChange(previous_state, immutable_state, keys) {  // AWH deleteme
    return did_any_change(previous_state, immutable_state, keys);
}

export function did_any_change(previous_state, immutable_state, keys) {
    var something_changed = false;
    _.forEach(keys, function (key) {
        if (didChange(previous_state, immutable_state, key))
        {
            something_changed=true;
            return;
        }
    });
    return something_changed;
}

export function did_any_value_change(imm_state_1, imm_state_2, keys) {
    var something_changed = false;
    _.forEach(keys, function (key) {
        if (didValueChange(imm_state_1, imm_state_2, key))
        {
            something_changed=true;
            return;
        }
    });
    return something_changed;
}

// returns true if the value is not undefined and not null
function doesValueExist(value){
    if(value !== undefined){
        return value !== null;
    }
    return false;
}


// WEBPACK FOOTER //
// ./js/utils.js